import { render, staticRenderFns } from "./ClientsView.vue?vue&type=template&id=97446aa2"
import script from "./ClientsView.vue?vue&type=script&lang=ts"
export * from "./ClientsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports